import { IForm } from '@hooks/useForm';
import { IStepper } from '@hooks/useStepper';
import { IComboTipoCobrancaChip, IContratoCliente } from '@model/ContratoCliente';
import { IComboVendedor } from '@model/Vendedor';
import React from 'react';
import { PageBox } from '../PageBox';
import { ContratoCommand } from './ContratoCommand';
import { ContratoFormulario } from './ContratoFormulario';

export type HomeContratoContratoProps = {
    form: IForm<Partial<IContratoCliente>>
    stepper: IStepper
    vendedorCombo: IComboVendedor
    tipoCobrancaChipCombo: IComboTipoCobrancaChip
}

export function HomeContratoContrato ({ form, stepper, vendedorCombo, tipoCobrancaChipCombo }: HomeContratoContratoProps) {
    return (
        <React.Fragment>
            <PageBox>
                <ContratoFormulario 
                    form={form}
                    vendedorCombo={vendedorCombo}
                    tipoCobrancaChipCombo={tipoCobrancaChipCombo}
                />
            </PageBox>

            <ContratoCommand
                form={form}
                stepper={stepper}
            />
        </React.Fragment>
    )
}